import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import {Route, Redirect, Navigate} from 'react-router-dom';

import { TitleComponent } from '_components/TitleComponent/TitleComponent';

import {
	logIt,
	empty,
	replaceVars,
	getRandomUrlAppendage, isTestMode
} from '__globals/global-functions';

import {
	addCSSClass,
	removeCSSClass,
} from '__globals/css-functions';

import {
	getJsonContent,
	setContent
} from '__globals/copy-functions';

import {
	processClearErrMsg,
	processClearEntryUpdated
} from '_features/entries/entry-slice';

import { 	
	goNextPage
} from '__globals/page-flow';
	
import {EntryFormRedux} from './EntryForm/EntryFormRedux';
import { processErrMsgDisplay, processClearStatus } from '_features/entries/entry-slice';
import { processJSON } from '_features/promotion/promotion-slice';
import {Trivia} from '_pages/Variations/Trivia/Trivia';
import {CustomContent} from '_pages/Variations/CustomContent/CustomContent';

import * as GC from "../../../__globals/GLOBAL-CONSTANTS";
import PageFlow from "../../__routes/PageFlow";

import TagManager from 'react-gtm-module';
import {PageBackgroundImages} from "../../../_components/PageBackgroundImages/PageBackgroundImages";
import {retrieveRaffleLocalStorage} from "../../../__globals/promocracy-functions";
import {hasPromoEnded, hasPromoStarted} from "../../../__globals/date-functions";
import {UniversalComponents} from "../../../_components/_UniversalComponents/UniversalComponents";

const tagManagerArgs = {
	dataLayer: {
		userId: '001',
		userProject: 'RSP',
		page: 'Enter',
		checkLoginIframe: false
	},
	dataLayerName: 'RSP'
}

var sanitizeHtml = require('sanitize-html');

var addOn = getRandomUrlAppendage("rd");


export const Enter = props => {

	logIt( "Enter IS CALLED", "", false );

	logIt( GC.PAGE_ENTER + " PAGE IS CALLED", null, false );
	const PAGE_DIV_NAME = "enter"; // use underscores
	const PAGE_KEY = "enter"; // use camel case
	const PAGE_IMAGE_KEY = "enter"; // use dashes
	const PAGE_JSON_KEY = GC.PAGE_ENTER; // use init caps

	TagManager.dataLayer(tagManagerArgs);

	const dispatch = useDispatch();
	
	const promotion = useSelector(state => state.promotion);
	logIt( "PROMOTION at Enter", promotion, true );
	
	const entry = useSelector(state => state.entry);
	//logIt( "ENTRY AT ENTER", entry, true );

	const gameClaim = useSelector(state => state.entry.gameClaim);
	logIt( "GAME CLAIM AT ENTER", gameClaim, true);

	const variables = useSelector(state => state.entry.variables);
	//logIt( "VARIABLES AT ENTER", variables, true );

	const token = useSelector(state => state.entry.token);
	//logIt( "TOKEN AT ENTER", token, false );

	let error = useSelector(state => state.entry.error);
	//logIt( "ERROR AT ENTER", error, true );

	let entryUpdated = useSelector(state => state.entry.entryUpdated);
	//logIt( "entryUpdated AT IWGameMatch", error, true );

	const PROMO_CONFIG = promotion.configuration;
	const CONFIG = useSelector(state => state.promotion.CONFIG);

	const setErrorMsgDisplay = (errMsg) => {
		dispatch( processErrMsgDisplay(errMsg) );
	}
	
	
	// LOCAL VARIABLES
	const [isLoading, setLoading] = useState(false);
	const [useRegistration, setUseRegistration] = useState(false);
	const [raffleOn, setRaffleOn] = useState(false);
	const [alreadyRaffled, setAlreadyRaffled] = useState(false);
	const [promoExpired, setPromoExpired] = useState( false );
	const [goNext, setGoNext] = useState(false);

	const setDisplayForm = (display) => {
		if ( display ) {
			removeCSSClass( "register_form", "formHide" );
			addCSSClass( "register_form", "formShow" );
		} else {
			removeCSSClass( "register_form", "formShow" );
			addCSSClass( "register_form", "formHide" );
		}
	}
	
	useEffect(() => {

		// check promo ended
		if ( !isTestMode(PROMO_CONFIG) ) {
			if ( hasPromoEnded(CONFIG.endDateMS) ) {
				setPromoExpired( true );
			}
		}

		let entryPageTop = getJsonContent( promotion, "Enter", "entryPageTop", "Fill out the form below to enter", entry );
		setContent( "entry_page_top", entryPageTop );

		let entryFormTop = getJsonContent(promotion, "Enter", "entryFormTop", "By entering this promotion you agree to <i>receive emails</i> from company.", entry);
		setContent("dv_entry_form_top", entryFormTop);

		let triviaOn = promotion.configuration.config?.variations?.trivia?.triviaOn;
		let hideEntry = promotion.configuration.config?.variations?.trivia?.hideEntryFormPreAnswer;
		if ( !empty(triviaOn) && !empty(hideEntry) ) {
			if ( hideEntry ) {
				removeCSSClass( "register_form", "formShow" );
				addCSSClass( "register_form", "formHide" );
			} else {
				removeCSSClass( "register_form", "formHide" );
				addCSSClass( "register_form", "formShow" );
			}
		}
		let ro = promotion.configuration.config?.variations?.raffle?.raffleOn;
		setRaffleOn( ro );
		let raffleStorage = retrieveRaffleLocalStorage();
		if ( !empty(raffleStorage) ) {
			setAlreadyRaffled(true);
		}
	}, [promotion]);
	
	useEffect(() => {
		if ( !empty(gameClaim) ) {
			if ( entryUpdated ) {
				dispatch( processClearEntryUpdated() );
			} else if ( !empty(entry?.errorMsgDisplay) ) {
				dispatch( processClearErrMsg() )
			} else {
				setGoNext( true );
			}
		}
	}, [gameClaim, entry.errorMsgDisplay] );

	useEffect(() => {
		if ( !empty(variables) ) {
			if ( entryUpdated ) {
				dispatch( processClearEntryUpdated() );
			} else if ( !empty(entry?.errorMsgDisplay) ) {
				dispatch( processClearErrMsg() )
			} else {
				setGoNext( true );
			}
		}
	}, [variables, entry.errorMsgDisplay] );

	useEffect(() => {
		if ( !empty(error) ) {
			if (!empty(entry?.errorMsgDisplay)) {
				dispatch(processClearErrMsg())
			} else {
				setGoNext(true);
			}
		}
	}, [error, entry.errorMsgDisplay] );

	useEffect(() => {
		if ( raffleOn && alreadyRaffled ) {
			setGoNext(true);
		}
	}, [raffleOn, alreadyRaffled] );

	useEffect(() => {
		if ( promoExpired ) {
			setGoNext(true);
		}
	}, [promoExpired] );

	if(isLoading) {

		return (<div id="dv_loading" className="background"><div className='loading'><div className='loading-copy'>loading:<div className='scrollingwords'><span>promotion</span><span>interface</span><span>prizes</span><span>rules</span><span>probabilities</span><span>winning plays</span></div></div></div></div>);

	} else if ( goNext ) {

		if ( raffleOn && alreadyRaffled ) {
			return (<PageFlow page={GC.PAGE_ENTER} error={error} raffleOn={true}/>);
		} else if ( promoExpired ) {
			return (<PageFlow page={GC.PAGE_APP} error={error} />);
		} else {
			return (<PageFlow page={GC.PAGE_ENTER} error={error} />);
		}

	} else {

		return (

			<React.Fragment>

				<TitleComponent title={promotion.configuration.promoCopy.GLOBAL.title} />

				<div id="register_page">

					<table>
						<tbody>
						<tr>
							<td className="page-visual">

								<PageBackgroundImages
									promotion={promotion}
									pageKey={"registration"}
								/>

							</td>
							<td className="page-content">

								<div id="entry_page_top"></div>

								<Trivia setDisplayForm={setDisplayForm} />

								<div id="register_form" className="formShow">

									<div id="dv_entry_form_top"></div>

									<EntryFormRedux
										errorMsgDisplay={entry.errorMsgDisplay}
										setErrorMsgDisplay={setErrorMsgDisplay}
									/>

								</div>

								<UniversalComponents
									promotion={promotion}
									configKey={PAGE_KEY}
								/>

							</td>
						</tr>
						</tbody>
					</table>

					<CustomContent />

				</div>


			</React.Fragment>

		);
	}
    
}

export default Enter;